import React from "react";
import RTooltip from "@reach/tooltip";
import "@reach/tooltip/styles.css";
import "./Tooltip.css";

export default function Tooltip(props) {
    return <RTooltip {...props} />;
}
